import { createContext } from "react";
import { injectIntl } from "react-intl";

const IntlContext = createContext(null);

export const IntlContextProvider = injectIntl(({ intl, children }) => (
  <IntlContext.Provider value={intl}>{children}</IntlContext.Provider>
));

export default IntlContext;
